<template>
    <div class="col-6 card border shadow-none mb-5">
        <div class="card-body pt-3">
            <div class="card-title d-flex align-items-center mb-3">
                <h5 class="mb-0">{{ $trans.get('__JSON__.Contract info')}}</h5>
            </div>

            <div class="d-flex align-items-center" v-if="loading">
                <span class="me-auto">{{ $trans.get('__JSON__.Loading...') }}</span>
                <div class="spinner-border spinner-border-sm ml-auto" role="status"></div>
            </div>

            <div v-if="data.contract">
                <div class="d-flex justify-content-between mt-3">
                    <div class="px-2 text-sm">
                        <i class="text-base text-muted bi bi-person-fill"></i> {{ data.contract.user_name }}
                    </div>
                    <div class="px-2 text-sm">
                        <span class="badge" :class="{ 'bg-soft-primary text-primary': data.contract.is_employment, 'bg-soft-dark text-dark': data.contract.is_placement }">
                            {{ data.contract.type }}
                        </span>
                    </div>
                </div>

                <div class="d-flex flex-column">
                    <div class="px-2 text-sm mt-2">
                        <i class="text-base text-muted bi bi-calendar-range-fill"></i>
                        {{ data.contract.start_date_view }} / {{data.contract.end_date_view ? data.contract.end_date_view : $trans.get('__JSON__.Undetermined time') }}
                    </div>
                    <div class="px-2 text-sm mt-2" v-if="data.contract.client_name">
                        <i class="text-base text-muted bi bi-buildings-fill"></i> {{ data.contract.client_name }}
                    </div>
                    <div class="px-2 text-sm mt-2" v-if="data.contract.location_name">
                        <i class="text-base text-muted bi bi-building-fill"></i> {{ data.contract.location_name }}
                    </div>
                    <div class="px-2 text-sm mt-2" v-if="data.contract.placement_function_name">
                        <i class="text-base text-muted bi bi-file-person-fill"></i> {{ data.contract.placement_function_name }}
                    </div>
                    <div class="px-2 text-sm mt-2" v-if="data.contract.placement_type_name">
                        <i class="text-base text-muted bi bi-file-text-fill"></i> {{ data.contract.placement_type_name }}
                    </div>
                    <div class="px-2 text-sm mt-2" v-if="data.contract.probation_name">
                        <i class="text-base text-muted bi bi-alarm-fill"></i> {{ data.contract.probation_name }}
                    </div>
                    <div class="px-2 text-sm mt-2" v-if="data.contract.phase_name">
                        <i class="text-base text-muted bi bi-file-earmark-x-fill"></i> {{ data.contract.phase_name }}
                    </div>
                    <div class="px-2 text-sm mt-2" v-if="data.contract.placement_employment_method_name">
                        <i class="text-base text-muted bi bi-box-arrow-down-right"></i> {{ data.contract.placement_employment_method_name }}
                    </div>
                    <div class="px-2 text-sm mt-2" v-if="data.contract.end_reason">
                        <i class="text-base text-muted bi bi-sign-stop-fill"></i> {{ data.contract.end_reason }}
                    </div>
                    <div class="px-2 text-sm mt-2" v-if="data.contract.end_specification">
                        <i class="text-base text-muted bi bi-question-octagon-fill"></i> {{ data.contract.end_specification }}
                    </div>
                    <div class="px-2 text-sm mt-2" v-if="data.contract.employment_name">
                        <i class="text-base text-muted bi bi-person-fill-up"></i> {{ data.contract.employment_name }}
                    </div>
                    <div class="px-2 text-sm mt-2" v-if="data.contract.employment_type_name">
                        <i class="text-base text-muted bi bi-file-text-fill"></i> {{ data.contract.employment_type_name }}
                    </div>
                    <div class="px-2 text-sm mt-2" v-if="data.contract.created_at">
                        <i class="text-base text-muted bi bi-plus-lg"></i> {{ data.contract.created_at }}
                    </div>
                    <div class="px-2 text-sm mt-2" v-if="data.contract.updated_at">
                        <i class="text-base text-muted bi bi-pencil-fill"></i> {{ data.contract.updated_at }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContractInfo',
    props: {
        loading: {
            type: Boolean,
            required: true,
        },
        data: {
            type: Object,
            required: false,
        },
    },
}
</script>
